import yup from '../yup';

export const userSchema = yup.object().shape({
  name: yup.string()
    .max(30, '名は30文字以下で入力してください。')
    .required('名を入力してください。')
    .label('名'),
  surname: yup.string()
    .max(30, '姓は30文字以下で入力してください。')
    .required('姓を入力してください。')
    .label('姓'),
  mail: yup.string()
    .label('メールアドレス')
    .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, '正しい形式のメールアドレスを入力してください。')
    .email('正しい形式のメールアドレスを入力してください。')
    .when('$isCreate', (isCreate, passSchema) => (isCreate
      ? passSchema
      : passSchema.required('メールアドレスを入力してください。'))),
  user_roles: yup.string()
    .typeError('権限を入力してください。')
    .label('権限')
    .when('$isCreate', (isCreate, passSchema) => (isCreate
      ? passSchema
      : passSchema.required('権限を入力してください。'))),
  password: yup
    .string()
    .min(8, 'パスワードは8文字以上で入力してください。')
    .matches(/[A-Z]/, 'パスワードには少なくとも1つの大文字を含めてください。')
    .matches(/[a-z]/, 'パスワードには少なくとも1つの小文字を含めてください。')
    .matches(/[0-9]/, 'パスワードには少なくとも1つの数字を含めてください。')
    .when('$isCreate', (isCreate, passSchema) => (isCreate
      ? passSchema

      : passSchema.required('パスワードを入力してください。'))),
  password_repeat: yup.string()
    .oneOf([yup.ref('password'), null], 'パスワードが一致しません。')
    .min(8, 'パスワードは8文字以上で入力してください。')
    .matches(/[A-Z]/, 'パスワードには少なくとも1つの大文字を含めてください。')
    .matches(/[a-z]/, 'パスワードには少なくとも1つの小文字を含めてください。')
    .matches(/[0-9]/, 'パスワードには少なくとも1つの数字を含めてください。')
    .when('$isCreate', (isCreate, passSchema) => (isCreate
      ? passSchema
      : passSchema.required('パスワードを入力してください。'))),
});
